module.exports = {"440703002":"白沙街道","440703005":"潮连街道","440703006":"环市街道","440703101":"棠下镇","440703102":"荷塘镇","440703103":"杜阮镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440703.json
// module id = 2116
// module chunks = 0